import React from "react";

const SupportTraderSection = (props) => {
  return (
    <div className="support-trader-container">
      <div className="title">提携業者について</div>
      <div className="sub-title">
        多くのメディア・専門家と提携し、会社経営に役立つ情報を取り入れています。
      </div>
      <div className="line"></div>
      <div className="supports-trader-content">
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">日経新聞</a>
            <span>日本経済新聞社</span>
          </div>
        </div>
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">Forbes JAPAN</a>
            <span>リンクタイズ</span>
          </div>
        </div>
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">Tech crunch</a>
            <span>Verizon Media Japan KK</span>
          </div>
        </div>
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">NewsPicks</a>
            <span>株式会社ユーザーベース</span>
          </div>
        </div>
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">SankeiBiz</a>
            <span>産経デジタル</span>
          </div>
        </div>
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">AP通信</a>
            <span>AP通信</span>
          </div>
        </div>
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">BBC News</a>
            <span>BBCグローバルニュースジャパン株式会社</span>
          </div>
        </div>
        <div className="supports-trader-area">
          <div className="supports-trader-area-wrap">
            <a href="#">CNN.co.jp</a>
            <span>CNN</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportTraderSection;
